import React from "react";
import { fileTypes } from "../../consts/consts";
import UploadFile from "../UploadFile/UploadFile";
import { fetchData } from "../Service/graphQlService";
import { GET_FILE_URL } from "../Graphql/Queries/getFileUrl";

export default class UploadFiles extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            currentMaxFiles: 1,
            uploadManually: false,
            items:[],
            fileurlLoaded:false
        };

        this.increaseMaxFiles = this.increaseMaxFiles.bind(this);

    }
    
    componentDidMount() {
        const {items, data, initialFilesAmount} = this.props;
        let fileCount = initialFilesAmount ? initialFilesAmount : items.reduce((count, item) => data[item.name] ? ++count : count, 0)
        this.setState({currentMaxFiles: fileCount || 1,items:items})
    }

     componentDidUpdate(prevProps, prevState) {
            const { items, data } = this.props;
            
            // Check if any file URL fields have been added/updated
            const hasNewFileUrls = items.some(item => {
                const urlFieldName = `${item.name}_url`;
                return data[urlFieldName] && data[urlFieldName] !== prevProps.data[urlFieldName];
            });
            
            if (hasNewFileUrls) {
                const itemsCopy = [...items];
                
                items.forEach((item, index) => {
                    const urlFieldName = `${item.name}_url`;
                    if (data[urlFieldName]) {
                        itemsCopy[index] = { ...itemsCopy[index], link: data[urlFieldName] };
                    }
                });
                
                this.setState({ items: itemsCopy, fileurlLoaded: true });
                return;
            }

            // A file was replaced or removed after the URLs were loaded: drop the stale link and fetch the new one
            if (this.state.fileurlLoaded) {
                items.forEach(item => {
                    const fileId = data[item.name];
                    if (fileId === prevProps.data[item.name]) return;
                    this.setItemLink(item.name, null);
                    if (fileId) {
                        fetchData(GET_FILE_URL, { id: fileId }).then(response => {
                            // Ignore the response if the file changed again while it was in flight
                            if (this.props.data[item.name] !== fileId) return;
                            if (response.data && response.data.getFile && response.data.getFile.fileUrl) {
                                this.setItemLink(item.name, response.data.getFile.fileUrl);
                            }
                        });
                    }
                });
            }

            // Original logic for initial load
            if (Object.keys(data).length && items.length && !this.state.fileurlLoaded){
                const itemsCopy = [...items]; // Create a new copy of items
                Promise.all(
                    items.map(async (item, index) => {
                        if (data[item.name]) {
                            // Check if we already have the URL from the recent API call
                            const urlFieldName = `${item.name}_url`;
                            if (data[urlFieldName]) {
                                itemsCopy[index] = { ...itemsCopy[index], link: data[urlFieldName] };
                            } else {
                                const response = await fetchData(GET_FILE_URL, { id: data[item.name] });
                                if (response.data && response.data.getFile && response.data.getFile.fileUrl) {
                                    itemsCopy[index] = { ...itemsCopy[index], link: response.data.getFile.fileUrl };
                                }
                            }
                        }
                    })
                ).then(() => {
                    this.setState({ items: itemsCopy ,fileurlLoaded:true}); 
                });
            }
        }

    setItemLink(name, link) {
        this.setState(prevState => ({
            items: prevState.items.map(item => item.name === name ? { ...item, link } : item)
        }));
    }

    increaseMaxFiles() {
        let currentMaxFiles = this.state.currentMaxFiles;
        const maxFiles = this.props.maxFilesAmount;

        if (currentMaxFiles + 1 <= maxFiles)
            this.setState({currentMaxFiles: currentMaxFiles + 1});
    }

    render() {
        const {data, handleChangeFile, viewMode, deleted, disabled, classNames, maxFilesAmount, canUploadManually, handleChangeInput} = this.props;
        const {items}= this.state
        const currentMaxFiles = this.state.currentMaxFiles;
        const uploadManually = this.state.uploadManually;
        const fileType = this.props.fileType ? this.props.fileType : fileTypes.Document;

        return (
            <React.Fragment>
                {
                    items.map((item,index) => {
                        if (index < currentMaxFiles)
                            return (
                                <UploadFile
                                    data={data}
                                    className={classNames}
                                    key={`${item.name}-${item.link || ''}`}
                                    label={item.label}
                                    name={item.name}
                                    link={item.link || data[item.name]}
                                    disabled={disabled}
                                    deleted={deleted}
                                    viewMode={viewMode}
                                    handleChange={handleChangeFile}
                                    fileType={fileType}
                                    uploadManually={uploadManually}
                                    handleChangeInput={handleChangeInput}
                                    path={item.link || data[item.name]}
                                />
                            );
                    })
                }
                {
                    currentMaxFiles < maxFilesAmount && !viewMode &&
                    <button
                        type='button'
                        className='button-new positive'
                        onClick={this.increaseMaxFiles}>
                        Add {fileType === fileTypes.Photo ? 'photo' : 'file'}
                    </button>
                }
                {
                    !viewMode && canUploadManually &&
                    <button
                        type='button'
                        className='button-new positive upload-type'
                        onClick={() => this.setState({uploadManually: !this.state.uploadManually})}>
                        Upload {uploadManually ? 'File' : 'Manually'}
                    </button>
                }
            </React.Fragment>
        );
    }
}
     